<script>
    import Title from "../../Components/Title.svelte";
    import {onMount} from "svelte";
    import {alertShown, documentData, modalCloseAction, modalComponent, modalData} from "../../Core/Store";
    import GenericLoading from "../../Modals/GenericLoading.svelte";
    import {handApi} from "../../Core/HandApi";
    import GenericError from "../../Modals/GenericError.svelte";
    import UnavailabilityDay from "../../Modals/UnavailabilityDay.svelte";

    let startDate = new Date();
    let dayOfWeek = startDate.getDay();
    startDate.setDate(startDate.getDate() - (dayOfWeek - 1));
    let currentDate = new Date(startDate);
    let today = new Date();
    let dateData = [];

    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    let unavailabilityData = [];
    let loadData = async () => {
        modalComponent.set(GenericLoading);
        alertShown.set(true);

        let results = await handApi.availability();

        if (results === null) {
            modalComponent.set(GenericError);
            return;
        }

        unavailabilityData = results;
        alertShown.set(false);
    };
    onMount(loadData);

    function showModal(dayData) {
        modalComponent.set(UnavailabilityDay);
        modalData.set(dayData);
        modalCloseAction.set(loadData);
        alertShown.set(true);
    }

    $: {
        dateData = [];
        currentDate = new Date(startDate);
        for(let i = 0; i < 28; i++) {
            let unavailabilityRecord = unavailabilityData.find(m => {
                return m.date.getDate() === currentDate.getDate() && m.date.getMonth() === currentDate.getMonth();
            });
            let dayData = {
                date: new Date(currentDate.getTime()),
                unavailable: unavailabilityRecord ?? null
            };
            dateData.push(dayData);
            currentDate.setDate(currentDate.getDate() + 1);
        }
    }
</script>

<div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
    <Title textColor="text-hand-pink-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <span>
            Availability
        </span>
    </Title>
</div>
<div class="max-w-6xl mx-auto px-2">
    <div class="grid grid-cols-7">
        {#each ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'] as day}
            <div class="bg-hand-pink-500 text-white p-1 text-xs font-bold text-center">
                {day}
            </div>
        {/each}
        {#each dateData as dayData, i}
            <div class={dayData.date.getDate() === today.getDate() && dayData.date.getMonth() === today.getMonth() ? 'bg-hand-pink-50 font-bold' : 'odd:bg-gray-100'} on:click={() => { if (dayData.date < today) return; showModal(dayData) }}>
                <div class="text-xs p-1 bg-gray-200 font-bold text-black">
                    {#if dayData.date.getDate() === 1 || i === 0 || i % 7 === 0}
                        {months[dayData.date.getMonth()]}
                    {:else}
                        &nbsp;
                    {/if}
                </div>
                <div class="text-center py-3" class:opacity-25={dayData.date < today}>
                    {dayData.date.getDate()}
                    <svg xmlns="http://www.w3.org/2000/svg"
                         class:text-green-600={dayData.unavailable === null}
                         class:text-red-600={dayData.unavailable !== null}
                         class="mx-auto mt-3 h-2 w-2" viewBox="0 0 14 14"><circle cx="7" cy="7" r="6.5" style="fill: currentColor;stroke:none;"></circle></svg>
                </div>
            </div>
        {/each}
    </div>
</div>